"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogActionsButton = exports.RadioInput = exports.SectionTitle = exports.BodyText = exports.StyledBulleList = void 0;
const material_1 = require("@mui/material");
exports.StyledBulleList = (0, material_1.styled)(material_1.Typography)(ownerState => {
    return {
        lineHeight: 'normal',
        marginTop: ownerState.theme.spacing(1),
        marginLeft: ownerState.theme.spacing(2),
        position: 'relative',
        ...(ownerState['aslink'] === 'true' && {
            textDecoration: 'underline',
            cursor: 'pointer',
        }),
        '&::before': {
            content: '"•"',
            position: 'absolute',
            left: `calc(-${ownerState.theme.spacing(2)})`,
            top: '1.5px',
        },
    };
});
exports.BodyText = (0, material_1.styled)(material_1.Typography)(({ theme }) => ({
    lineHeight: 'normal',
    marginTop: theme.spacing(1),
    marginBottom: '0',
}));
exports.SectionTitle = (0, material_1.styled)(material_1.Typography)(({ theme }) => ({
    lineHeight: 'normal',
    marginTop: theme.spacing(1),
    marginBottom: 0,
    padding: 0,
    '&::after': {
        content: 'none',
    },
}));
exports.RadioInput = (0, material_1.styled)(material_1.Radio)(({ theme }) => ({
    '&.Mui-checked': {
        color: `${theme.palette.hsbcColor.blue_sapphire} !important`,
    },
    '&.Mui-checked .MuiSvgIcon-root path': {
        fill: `${theme.palette.hsbcColor.blue_sapphire} !important`,
    },
}));
exports.DialogActionsButton = (0, material_1.styled)(material_1.Button)(({ theme }) => ({
    padding: '10px 0',
    maxWidth: '50%',
    boxSizing: 'border-box',
    textTransform: 'uppercase',
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textWrap: 'inherit',
    '&:hover': {
        backgroundColor: theme.palette.tsGoColor.grayLight(0.3),
    },
}));
